import { DatesProvider } from "@mantine/dates"
import { useTranslation } from "react-i18next"

export function I18nMantineDatesProvider(props: React.PropsWithChildren) {
  const { i18n } = useTranslation()
  return (
    <DatesProvider
      settings={{ locale: i18n.language === "en" ? "en-gb" : i18n.language }}
    >
      {props.children}
    </DatesProvider>
  )
}
